var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
         'page-a' : _vm.$route.name == 'Home',
         'page-new' : _vm.$route.name == 'HomeNew',
         'page-b' : _vm.$route.name == 'HomeB'
    },attrs:{"id":"app"}},[_c('router-view'),_c('ModalContainer',[_c('Terms')],1),_c('Clarity'),(_vm.$store.state.formSuccess)?_c('KwPixel'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }